// extracted by mini-css-extract-plugin
export var actionButton = "_p4-0";
export var actionMenuContainer = "_p4-i";
export var bubble = "_p4-2";
export var bubbleActionMenu = "_p4-j";
export var bubbleContext = "_p4-6";
export var bubbleItems = "_p4-7";
export var customer = "_p4-3";
export var divider = "_p4-8";
export var fileList = "_p4-9";
export var hiddenComment = "_p4-o";
export var infoAbove = "_p4-a";
export var internal = "_p4-4";
export var lightActionButton = "_p4-1";
export var link = "_p4-b";
export var merchant = "_p4-5";
export var message = "_p4-c";
export var profilePicture = "_p4-e";
export var quillToolbarContainer = "_p4-f";
export var senderDate = "_p4-g";
export var senderDateCustomer = "_p4-h";
export var senderName = "_p4-d";
export var time = "_p4-k";
export var uploadedImage = "_p4-l";
export var username = "_p4-m";
export var xsmall = "_p4-n";